<template>
  <div>
    <v-toolbar flat color="white">
      <v-toolbar-title>Raporlar</v-toolbar-title>
    </v-toolbar>
    
    <!-- Responsive Filter Container -->
    <v-container fluid class="pa-2">
      <v-layout wrap>
        <v-flex xs12 md12>
          <v-layout wrap>
            <v-flex xs12 sm6 md3 class="px-1">
              <v-menu
                  v-model="menu1"
                  :close-on-content-click="false"
                  lazy
                  transition="scale-transition"
                  offset-y
                  full-width
                  min-width="290px"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                      v-model="startDate"
                      label="Baş. Tarihi"
                      prepend-icon="event"
                      readonly
                      v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker
                    @change="initialize"
                    v-model="startDate"
                    locale="tr-TR"
                    @input="menu1 = false"
                ></v-date-picker>
              </v-menu>
            </v-flex>
            
            <v-flex xs12 sm6 md3 class="px-1">
              <v-menu
                  v-model="menu2"
                  :close-on-content-click="false"
                  lazy
                  transition="scale-transition"
                  offset-y
                  full-width
                  min-width="290px"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                      v-model="endDate"
                      label="Bit. Tarihi"
                      prepend-icon="event"
                      readonly
                      v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker
                    @change="initialize"
                    v-model="endDate"
                    locale="tr-TR"
                    @input="menu2 = false"
                ></v-date-picker>
              </v-menu>
            </v-flex>
            
            <v-flex xs12 sm6 md3 class="px-1">
              <v-combobox
                  v-model="selectState"
                  :items="this.$store.getters['orders/getStateItems']"
                  item-value="id"
                  @change="initialize"
                  item-text="value"
                  label="Sipariş Durumları"
                  clearable
              ></v-combobox>
            </v-flex>
            
            <v-flex xs12 sm6 md3 class="px-1">
              <v-combobox
                  v-model="selectCategory"
                  :items="$store.state.productCategory.all"
                  item-value="id"
                  item-text="name"
                  @change="initialize"
                  label="Kategori"
                  clearable
              ></v-combobox>
            </v-flex>
          </v-layout>
        </v-flex>
        
        <v-flex xs12 class="text-center mt-2">
          <v-btn color="primary" @click="initialize">
            <v-icon left>search</v-icon>
            Ara
          </v-btn>
        </v-flex>
      </v-layout>
    </v-container>

    <v-container grid-list-xl>
      <v-layout wrap justify-space-between>
        <v-flex xs12 md6>
          <v-toolbar flat color="white">
            <v-toolbar-title>Ürüne Göre Satışlar</v-toolbar-title>
          </v-toolbar>
          <v-data-table
              :headers="productHeaders"
              :loading="this.$store.state.progress"
              :items="this.$store.state.reports.bestSellingProducts"
              hide-actions
          >
            <template v-slot:headers="props">
              <tr>
                <th
                    v-for="header in props.headers"
                    :key="header.text"
                    :class="[
                    'column sortable',
                    pagination.descending ? 'desc' : 'asc',
                    header.value === pagination.sortBy ? 'active' : '',
                  ]"
                    @click="changeSort(header.value)"
                >
                  {{ header.text }}
                  <v-icon small>arrow_upward</v-icon>
                </th>
              </tr>
            </template>
            <template v-slot:items="props">
              <tr>
                <td class="text-xs-center">{{ props.item.productName }}</td>
                <td class="text-xs-center">{{ props.item.count }}</td>
                <td class="text-xs-center">
                  {{ props.item.totalAmount | formatMoney }}
                </td>
              </tr>
            </template>
          </v-data-table>
        </v-flex>
        <v-flex xs12 md6>
          <v-toolbar flat color="white">
            <v-toolbar-title>Kategorilere Göre Satışlar</v-toolbar-title>
          </v-toolbar>
          <v-data-table
              :headers="productHeaders"
              :loading="this.$store.state.progress"
              :items="this.$store.state.reports.bestSellingCategories"
              hide-actions
          >
            <template v-slot:headers="props">
              <tr>
                <th
                    v-for="header in props.headers"
                    :key="header.text"
                    :class="[
                    'column sortable',
                    pagination.descending ? 'desc' : 'asc',
                    header.value === pagination.sortBy ? 'active' : '',
                  ]"
                    @click="changeSort(header.value)"
                >
                  {{ header.text }}
                  <v-icon small>arrow_upward</v-icon>
                </th>
              </tr>
            </template>
            <template v-slot:items="props">
              <tr>
                <td class="text-xs-center">{{ props.item.productName }}</td>
                <td class="text-xs-center">{{ props.item.count }}</td>
                <td class="text-xs-center">
                  {{ props.item.totalAmount | formatMoney }}
                </td>
              </tr>
            </template>
          </v-data-table>
        </v-flex>

      </v-layout>
    </v-container>
  </div>
</template>
<script>


export default {
  data: () => ({
    startDate: new Date().toISOString().substr(0, 10),
    endDate: new Date().toISOString().substr(0, 10),
    menu1: false,
    tenantId: 0,
    menu2: false,
    hasAverage: null,
    selectState: {id: -1, value: "Tümü"},
    selectCategory: {id: -1, name: "Tümü"},
    selected: [],
    pagination: {
      sortBy: "name",
    },
    pageItems: [
      25,
      50,
      { text: "$vuetify.dataIterator.rowsPerPageAll", value: -1 },
    ],
    productHeaders: [
      {
        text: "Ürün",
        value: "state",
      },
      {text: "Adet", value: "count"},
      {text: "Sipariş Tutarı", value: "totalAmount"},
    ],

  }),
  watch: {
    dialog(val) {
      val || this.close();
    },
  },

  created() {
    //this.initialize();
  },

  methods: {
    changeSort(column) {
      if (this.pagination.sortBy === column) {
        this.pagination.descending = !this.pagination.descending;
      } else {
        this.pagination.sortBy = column;
        this.pagination.descending = false;
      }
    },
    async initialize() {
       this.$store.dispatch("reports/getBestSellingProductsReports", {
        startDate: this.startDate,
        endDate: this.endDate,
        categoryId: this.selectCategory.id,
        stateId: this.selectState.id,
      });
       this.$store.dispatch("reports/getBestSellingCategoriesReports", {
        startDate: this.startDate,
        endDate: this.endDate,
        categoryId: this.selectCategory.id,
        stateId: this.selectState.id,
      });
    },
  },
  async mounted() {
    await this.$store.dispatch("productCategory/getAllProductCategories");
    this.tenantId = localStorage.getItem("tenantId");
    await this.initialize();
  },
};
</script>
<style>
.redd {
  color: red;
}
</style>
